import { render, staticRenderFns } from "./adminMainPage.vue?vue&type=template&id=61635632&"
import script from "./adminMainPage.vue?vue&type=script&lang=js&"
export * from "./adminMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports